export function UnifiedDiffTable(props: React.PropsWithChildren<{lineWidth: string; showLineNumbers?: boolean}>) {
  const showLineNumbers = props.showLineNumbers ?? true

  return (
    <>
      <thead className="sr-only">
        <tr>
          {showLineNumbers && <th scope="col">Original file line number</th>}
          {showLineNumbers && <th scope="col">Diff line number</th>}
          <th scope="col">Diff line change</th>
        </tr>
      </thead>
      <colgroup>
        {showLineNumbers && <col width={props.lineWidth} />}
        {showLineNumbers && <col width={props.lineWidth} />}
        <col width="100%" />
      </colgroup>
      <tbody>{props.children}</tbody>
    </>
  )
}
